
import "./nvq-workshop-gampaha.css"
import React, { useState } from 'react';
import 'react-image-lightbox/style.css';
import Lightbox from 'react-image-lightbox';



import nvq1 from '../../assets/g1.jpeg';
import nvq2 from '../../assets/g2.jpeg';
import nvq3 from '../../assets/g3.jpeg'; 
import nvq4 from '../../assets/g4.jpeg';
import nvq7 from '../../assets/g5.jpeg';
import nvq5 from '../../assets/g6.jpeg';
import nvq6 from '../../assets/g7.jpeg';
import nvq8 from '../../assets/g8.jpeg';
import nvq9 from '../../assets/g9.jpeg';
import nvq10 from '../../assets/g10.jpeg';
import nvq11 from '../../assets/g11.jpeg';
import nvq12 from '../../assets/g12.jpeg';



const sections = [

  {
    title: '',
    images: [nvq1, nvq11, nvq4, nvq8  ],
  },


{
images: [ nvq3, nvq2, nvq5, nvq6,],

},

    {
   
    images: [nvq7, nvq9, nvq10,  nvq12],
  },




]





const NvqWorkshopGampaha = () => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);

  const openViewer = (images, index) => {
    setCurrentImages(images);
    setPhotoIndex(index);
    setIsViewerOpen(true);
  };

  const closeViewer = () => {
    setIsViewerOpen(false);
  };

  return (
    <div className="gallery">
        <h1 align="center">NVQ Workshop Gampaha - 2026 | Phase 02 </h1>
        <p className="intro-annualmeeting">
        Be Qualified, Be Certified 🎓👀 Phase 02 in Gampaha, held on 29th March 2026, 
        was successfully completed. A heartfelt thank you to everyone who participated 
        in our NVQ Level 3 and Level 5 Workshop. Your dedication, enthusiasm, 
        and commitment made this event a great success.
        </p>
      <br />
      {sections.map((section, sectionIndex) => (
        <div key={sectionIndex} className="gallery-section">
          <div className="gallery-header">
            <h2>{section.title}</h2>
          </div>
          <div className="gallery-grid">
            {section.images.map((src, index) => (
              <div key={index} className="gallery-item">
                <div className="overlay-container">
                <img
                    src={src}
                    alt={`Gallery item ${index + 1} in ${section.title}`} // Avoid the word "image"
                    className="gallery-image"
                    onClick={() => openViewer(section.images, index)}
                  />

                  <div className="overlay">
                    <button
                      className="max-view-button"
                      onClick={() => openViewer(section.images, index)}
                    >
                      <span>&#x2922;</span> {/* Fullscreen icon */}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {isViewerOpen && (
        <Lightbox
          mainSrc={currentImages[photoIndex]}
          nextSrc={currentImages[(photoIndex + 1) % currentImages.length]}
          prevSrc={
            currentImages[
              (photoIndex + currentImages.length - 1) % currentImages.length
            ]
          }
          onCloseRequest={closeViewer}
          onMovePrevRequest={() =>
            setPhotoIndex(
              (photoIndex + currentImages.length - 1) % currentImages.length
            )
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % currentImages.length)
          }
        />
      )}
    </div>
  );
};


export default NvqWorkshopGampaha